import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'
import {BSpinner} from 'bootstrap-vue'
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import { faAngleLeft, faAngleRight, faAngleUp, faAngleDown, faCirclePause, faArrowRotateRight } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faAngleLeft, faAngleRight, faAngleUp, faAngleDown, faCirclePause, faArrowRotateRight)

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)
import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)

import counters from './stores/counters'
import settings from './stores/settings'
import leagues from './stores/visibleLeagueViews'
Vue.use(Vuex)

let store = new Vuex.Store({
  modules: {
    counters,
    settings,
    leagues,
  }
})
import translations from './services/Translations'
let translate = new translations()
Vue.prototype.translate = function (type, code, language){
  return translate.translate(type, code, language)
}

window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', 'G-6E96TMH46S');

Vue.prototype.$gtag = function (label){
  console.log(label)
  gtag('event', 'Banner_click', {
    'event_label': label,
    'event_category': 'm88_odds_feed'
  });
}

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('b-spinner', BSpinner)

Vue.config.productionTip = false

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  store,
}).$mount('#app')

Vue.use(BootstrapVue);